// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_time_minute = /** @type {(inputs: {}) => string} */ () => {
	return `minute`
};

const de_widget_time_minute = /** @type {(inputs: {}) => string} */ () => {
	return `Minute`
};

const es_widget_time_minute = /** @type {(inputs: {}) => string} */ () => {
	return `minuto`
};

const fr_widget_time_minute = /** @type {(inputs: {}) => string} */ () => {
	return `minute`
};

const fi_widget_time_minute = /** @type {(inputs: {}) => string} */ () => {
	return `minuutti`
};

const hi_widget_time_minute = /** @type {(inputs: {}) => string} */ () => {
	return `मिनट`
};

const ja_widget_time_minute = /** @type {(inputs: {}) => string} */ () => {
	return `分`
};

const nl_widget_time_minute = /** @type {(inputs: {}) => string} */ () => {
	return `minuut`
};

const pt_widget_time_minute = /** @type {(inputs: {}) => string} */ () => {
	return `minuto`
};

const ro_widget_time_minute = /** @type {(inputs: {}) => string} */ () => {
	return `minut`
};

const th_widget_time_minute = /** @type {(inputs: {}) => string} */ () => {
	return `นาที`
};

const ur_widget_time_minute = /** @type {(inputs: {}) => string} */ () => {
	return `منٹ`
};

const zh_hant1_widget_time_minute = /** @type {(inputs: {}) => string} */ () => {
	return `分鐘`
};

const da_widget_time_minute = /** @type {(inputs: {}) => string} */ () => {
	return `minut`
};

const it_widget_time_minute = /** @type {(inputs: {}) => string} */ () => {
	return `minuto`
};

const vn_widget_time_minute = /** @type {(inputs: {}) => string} */ () => {
	return `phút`
};

const ko_widget_time_minute = /** @type {(inputs: {}) => string} */ () => {
	return `분`
};

const tr_widget_time_minute = /** @type {(inputs: {}) => string} */ () => {
	return `dakika`
};

const lv_widget_time_minute = /** @type {(inputs: {}) => string} */ () => {
	return `minūte`
};

const ar_widget_time_minute = /** @type {(inputs: {}) => string} */ () => {
	return `دقيقة`
};

const bs_widget_time_minute = /** @type {(inputs: {}) => string} */ () => {
	return `minut`
};

const sl_widget_time_minute = /** @type {(inputs: {}) => string} */ () => {
	return `minuta`
};

const id_widget_time_minute = /** @type {(inputs: {}) => string} */ () => {
	return `menit`
};

const sv_widget_time_minute = /** @type {(inputs: {}) => string} */ () => {
	return `minut`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_time_minute = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_time_minute(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_time_minute", locale)
	if (locale === "en") return en_widget_time_minute(inputs)
	if (locale === "de") return de_widget_time_minute(inputs)
	if (locale === "es") return es_widget_time_minute(inputs)
	if (locale === "fr") return fr_widget_time_minute(inputs)
	if (locale === "fi") return fi_widget_time_minute(inputs)
	if (locale === "hi") return hi_widget_time_minute(inputs)
	if (locale === "ja") return ja_widget_time_minute(inputs)
	if (locale === "nl") return nl_widget_time_minute(inputs)
	if (locale === "pt") return pt_widget_time_minute(inputs)
	if (locale === "ro") return ro_widget_time_minute(inputs)
	if (locale === "th") return th_widget_time_minute(inputs)
	if (locale === "ur") return ur_widget_time_minute(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_time_minute(inputs)
	if (locale === "da") return da_widget_time_minute(inputs)
	if (locale === "it") return it_widget_time_minute(inputs)
	if (locale === "vn") return vn_widget_time_minute(inputs)
	if (locale === "ko") return ko_widget_time_minute(inputs)
	if (locale === "tr") return tr_widget_time_minute(inputs)
	if (locale === "lv") return lv_widget_time_minute(inputs)
	if (locale === "ar") return ar_widget_time_minute(inputs)
	if (locale === "bs") return bs_widget_time_minute(inputs)
	if (locale === "sl") return sl_widget_time_minute(inputs)
	if (locale === "id") return id_widget_time_minute(inputs)
	if (locale === "sv") return sv_widget_time_minute(inputs)
	return "widget_time_minute"
};